var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mention-panel__mention-list"},_vm._l((_vm.mentions),function(mention){return _c('mention-item',{key:mention.id,attrs:{"mention":mention}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }